export function getDisplayName(
  name: string,
  email: string,
  userPhotoUrl?: string,
) {
  return userPhotoUrl || name || email || 'Unknown';
}
